module.exports = __webpack_public_path__ + "static/media/1.1a6a05e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/galaxyRewards/1.png
// module id = 2066
// module chunks = 0